import { render, staticRenderFns } from "./AddNewAddressModal.vue?vue&type=template&id=6af46f9c"
import script from "./AddNewAddressModal.vue?vue&type=script&lang=js"
export * from "./AddNewAddressModal.vue?vue&type=script&lang=js"
import style0 from "./AddNewAddressModal.vue?vue&type=style&index=0&id=6af46f9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports